export const SEARCH_WINDOW_OPEN = 'SEARCH_WINDOW_OPEN';

export const setSearchWindowOpen = open => ({
    type: SEARCH_WINDOW_OPEN,
    payload: {
        open
    }
})